import { PatientSeparateResidenceEditDrawer } from '@app/icare/entities/patient/edits/PatientSeparateResidenceEditDrawer'
import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { patientSeparateResidenceQueries } from '@app/icare/entities/patient/queries/patientSeparateResidenceQueries'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import type { PatientSeparateResidenceRelation } from '@app/icare/entities/patient/schema/PatientSeparateResidence'
import { RelationTabs } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationTabs'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_residences/aufenthaltsorte')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(patientSeparateResidenceQueries.forTabs(params.id)),
      queryClient.ensureQueryData(patientFindingsQueryOptions(params.id)),
    ]),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: residences = [] } = useSuspenseQuery(patientSeparateResidenceQueries.forTabs(id))
  const { data: findings = [] } = useQuery(patientFindingsQueryOptions(id))
  const { data: totalCount } = useQuery(patientSeparateResidenceQueries.totalCount(id))
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientSeparateResidenceRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/aufenthaltsorte/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })

  return (
    <RelationTabs
      relations={residences}
      relationTotalCount={totalCount}
      basePath={`/patienten/${id}/aufenthaltsorte`}
      findings={findings}
      findingsGroup="separateResidences"
      onAdd={params =>
        void PatientSeparateResidenceEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
      addLabel={t`Aufenthaltsort hinzufügen`}
    />
  )
}
